export const ENERGY_UNIT = {
  KWH: "KWH",
  BTU: "BTU",
};

export const KWH_TO_BTU_MULTIPLIER = 3412.14;

const BTU_INTEGER_FORMATTER = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});

export const getEnergyUnitLabel = (energyUnit) => (
  energyUnit === ENERGY_UNIT.BTU ? "BTU" : "kWh"
);

export const convertKWhToPreferredUnit = (value, energyUnit) => {
  const numericValue = Number(value) || 0;

  if (energyUnit === ENERGY_UNIT.BTU) {
    return numericValue * KWH_TO_BTU_MULTIPLIER;
  }

  return numericValue;
};

export const formatConvertedEnergyValue = (
  value,
  energyUnit,
  fractionDigits = 2
) => {
  const numericValue = Number(value) || 0;

  if (energyUnit === ENERGY_UNIT.BTU) {
    return BTU_INTEGER_FORMATTER.format(numericValue);
  }

  return numericValue.toFixed(fractionDigits);
};

export const formatEnergyValue = (value, energyUnit, fractionDigits = 2) => (
  formatConvertedEnergyValue(
    convertKWhToPreferredUnit(value, energyUnit),
    energyUnit,
    fractionDigits
  )
);

export const formatEnergyWithUnit = (value, energyUnit, fractionDigits = 2) => (
  `${formatEnergyValue(value, energyUnit, fractionDigits)} ${getEnergyUnitLabel(energyUnit)}`
);
